module.exports = __webpack_public_path__ + "static/media/qrcode_mini_lu.8a4edf23.svg";